module.exports = __webpack_public_path__ + "static/media/watchlist_descending_sort.3b4c4508.svg";